import { render, staticRenderFns } from "./StudentPreviewPlaceholder.vue?vue&type=template&id=2fac8722"
import script from "./StudentPreviewPlaceholder.vue?vue&type=script&lang=js"
export * from "./StudentPreviewPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./StudentPreviewPlaceholder.vue?vue&type=style&index=0&id=2fac8722&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports